import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE, STATISTICS_RRPP_ROUTE } from "../../config/RoutesConstants"
import { 
  Checkbox,
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  FormControl,
  FormControlLabel,
  Grid,
  GridList,
  GridListTile,
  List,
  ListItem,
  Paper,
  Tab,
  Tabs,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Typography, 
  Tooltip,
  TextField,
  Icon,
  Toolbar,
  MenuItem,
  Select  
} from "@material-ui/core"
import StatCard from "../../components/Stats/StatCard"
import TopCard from "../../components/Stats/TopCard"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ArrowRightIcon from '@material-ui/icons/ChevronRight'
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import { actionOrdersStats, actionMenuStats, actionTopClientStats, actionLiqResumeStats, actionLiqDetailStats } from '../../actions/StatsActions'
import { actionGetTicketTypes, registerOnChangeOrders } from "../../actions/RestaurantActions"
import { loading } from "../../actions/AppActions"
import {BarChart, Bar, CartesianAxis, LineChart, Line, XAxis, YAxis, ResponsiveContainer, Label, Legend, Tooltip as TooltipBar, Customized} from "recharts"
import Mock from "../../common/Mocks"
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment'
import ButtonCalendar from "../../components/ButtonCalendar/ButtonCalendar"
import ListAlt from '@material-ui/icons/ListAlt';
import EmptyProfile from "../../common/assets/profile_icon.png"
import CircularProgress from '@material-ui/core/CircularProgress';
import GridTotal from "../../components/GridTotal/GridTotal"
import TableLiq from "../../components/TableLiq/TableLiq"
import _ from "lodash"
let _handleSubmitFail;
//AGREGAR LIVE DATA o BOTON PARA ACTUALIZAR LOS DATOS
/*
CANTIDAD DE ÍTEMS DEL MENÚ
	IMPORTE (SUMATORIA DE LOS IMPORTES DE LOS ÍTEMS VENDIDO)
	TAKEAWAY (CANTIDAD)
	DELIVERY (CANTIDAD)
	EFECTIVO (CANTIDAD EN EFECTIVO)
	TARJETA DE CRÉDITO / DÉBITO (CANTIDAD EN PAGOS ELECTRÓNICOS)

*/
const aux = [0,1,2,3]
class Statistics extends React.PureComponent{
  constructor(props){
    super(props)
    let d = aux.map((i)=>{
      return {from:new Date(moment().add(-i,'d').format("MM-DD-YYYY")), to:null, open:false}}
    )
    let w = aux.map((i)=>{
      let f = moment().add(-i*7-6,'d')
      let e = moment().add(-i*7,'d')
      return {from:new Date(f.format("MM-DD-YYYY")), to:new Date(e.format("MM-DD-YYYY")), open:false}}
    )
    let m = aux.map((i)=>{
      return {from:new Date(moment().add(-i,'M').format("MM-DD-YYYY")), to:null, open:false}}
    )
    let c = aux.map((i)=>{
      let ft = new Date(moment().add(-i,'d').format("MM-DD-YYYY"))
      return {from:ft, to:ft, open:false}}
    )
    this.state={takeAway:true, delivery:true, table:true, cash:true, card:true, tabIndexSelected:0, selectedDaate1:new Date(), 
      dayly:d.slice(0),
      weekly:w.slice(0),
      monthly:m.slice(0),
      custom:c.slice(0),
      periodType:"dayly",
      unit:"Qt",
      items:"top15",
      fromTab1:new Date(moment().add(-1,'d').format("MM-DD-YYYY")),
      endTab1:new Date(moment().format("MM-DD-YYYY")),
      fromTab2:new Date(moment().add(-12,'month').format("MM-DD-YYYY")),
      endTab2:new Date(moment().format("MM-DD-YYYY")),
      orderStats:new Array(4),
      topClientStats:new Array(4),
      queryData:true,
      loadingData:[false,false,false,false],
      dayDetailLiq:{},
      detailLiq:{}
    }
    this.onChangeTab=this.onChangeTab.bind(this)
    this.onChangeCalendar=this.onChangeCalendar.bind(this)
    this.onSelectCalendar=this.onSelectCalendar.bind(this)
    this.onChangePeriod=this.onChangePeriod.bind(this)
    this.onChangeUnit=this.onChangeUnit.bind(this)
    this.onChangeItems=this.onChangeItems.bind(this)
    this.onOpenCalendar=this.onOpenCalendar.bind(this)
    this.onChangeDatesFromTab1=this.onChangeDatesFromTab1.bind(this)
    this.onChangeDatesEndTab1=this.onChangeDatesEndTab1.bind(this)
    this.onChangeDatesFromTab2=this.onChangeDatesFromTab2.bind(this)
    this.onChangeDatesEndTab2=this.onChangeDatesEndTab2.bind(this)
    this.onChangeCheck=this.onChangeCheck.bind(this)
    this.onViewDaylyDetailLiq=this.onViewDaylyDetailLiq.bind(this)
    this.onViewDetailLiq=this.onViewDetailLiq.bind(this)
    this.renderFilterWeekly=this.renderFilterWeekly.bind(this)
    this.queryStats=this.queryStats.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
    this.unsubscribe=null

  }

  componentWillMount(){
    if(!this.props.login){ 
      this.props.history.replace(LOGIN_ROUTE);
    }else{
      this.unsubscribe = registerOnChangeOrders(this.props.restaurant,()=>{
        let p = this.state.periodType
        if(this.state.tabIndexSelected==0){
          let d = this.state[p]
          for(let i = 0;i<d.length;i++){
            let query=false
            if(d[i].from){
              if(p=="weekly"||p=="custom"){
                query = d[i].to&&moment(d[i].from).isSameOrBefore(moment(),'d')&&moment(d[i].to).isSameOrAfter(moment(),'d')
              }else{
                if(p=="dayly"){
                  query = moment(d[i].from).isSameOrBefore(moment(),'d')
                }else{
                  query = moment(d[i].from).isSameOrBefore(moment(),'M')
                }
              }
            }
            if(query){
              this.queryStats(i, this.state.queryData) 
            }
          }
        }
        if(this.state.tabIndexSelected==1){
          if(moment(this.state.fromTab1).isSameOrBefore(moment(),'d')&&moment(this.state.endTab1).isSameOrAfter(moment(),'d')){
            this.queryStats(0, this.state.queryData)
          }
        }
        if(this.state.tabIndexSelected==2){
          if(moment(this.state.endTab2).isSameOrAfter(moment(),'month')){
            this.queryStats(0, this.state.queryData)
          }
        }
        this.state.queryData&&this.setState({queryData:false})
     })
      this.props.actionGetTicketTypes()
      
     
    }
  }

  componentWillUnmount(){
    this.unsubscribe&&this.unsubscribe()
  }

  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  queryError(index, useLoading){
    let loadingData = this.state.loadingData
    loadingData[index]=false
    this.setState({loadingData:loadingData})
    useLoading&&this.props.isLoading&&this.props.loading(false)
    Util.showNoty(ERROR, "Ocurrió un error al consultar los datos. Intente nuevamente")
  }

  queryStats(index, useLoading){
    let loadingData = this.state.loadingData
    loadingData[index]=true
    this.setState({loadingData:loadingData})
    useLoading&&this.props.loading(true)
    if(this.state.tabIndexSelected==2){
      this.props.actionLiqResumeStats([this.state.fromTab2, this.state.endTab2], false, 
        (response)=>{
          let dayDetailLiqKey = moment().format("MMMM YYYY")
          if(this.state.dayDetailLiq[dayDetailLiqKey]){
            let today = moment().toDate()
            this.props.actionLiqResumeStats([today,today], true, 
              (monthResume)=>{
                let dayDetailLiq = {...this.state.dayDetailLiq}
                dayDetailLiq[dayDetailLiqKey] = monthResume
                this.setState({dayDetailLiq:dayDetailLiq})
              },
              ()=>{this.queryError(index, useLoading)}
            )
          }
          if(this.state.detailLiq[moment().format("dddd DD")]){ //Si está el detalle desplegado
            this.props.actionLiqDetailStats(moment().toDate(), 
              (dayDetail)=>{
                let detailLiq = {...this.state.detailLiq}
                detailLiq[moment().format("dddd DD")] = dayDetail
                this.setState({detailLiq:detailLiq})
              },
              ()=>{this.queryError(index, useLoading)}
            )
          }
          useLoading&&this.props.isLoading&&this.props.loading(false)
        }, 
        ()=>{this.queryError(index, useLoading)})   
    }else{
      let orderType = []
      if(this.state.takeAway){
        orderType.push("takeAway")
      }
      if(this.state.delivery){
        orderType.push("delivery")
      }
      if(this.state.table){
        orderType.push("table")
      }
      let paymentMethod = []
      if(this.state.cash){
        paymentMethod.push("cash")
      }
      if(this.state.card){
        paymentMethod.push("credit-card")
      }
      let p = this.state.periodType
      let d = this.state[p]
      if(this.state.tabIndexSelected==0){
        this.props.actionOrdersStats(d[index], p, orderType, paymentMethod, 
          (response)=>{
            let orderStats = this.state.orderStats.slice(0)
            orderStats[index]=response
            this.setState({orderStats:orderStats})
            useLoading&&this.props.isLoading&&this.props.loading(false)
          }
          , ()=>{this.queryError(index, useLoading)}
        )
        useLoading&&this.props.loading(true)
        this.props.actionTopClientStats(d[index], p, orderType, paymentMethod, 
          (response)=>{
            let topClientStats = this.state.topClientStats.slice(0)
            topClientStats[index]=response
            loadingData[index]=false
            this.setState({topClientStats:topClientStats, loadingData:loadingData})
            useLoading&&this.props.isLoading&&this.props.loading(false)
          }
          , ()=>{this.queryError(index, useLoading)}
        )
        
      }
      if(this.state.tabIndexSelected==1){
        let unit = this.state.unit
        let top = this.state.items
        this.props.actionMenuStats([this.state.fromTab1, this.state.endTab1], p, unit, top, orderType, paymentMethod, ()=>{useLoading&&this.props.isLoading&&this.props.loading(false)}, ()=>{this.queryError(index, useLoading)})   
      }
    }
  }

  onChangeTab(evt, newIndex){
    this.setState({tabIndexSelected:newIndex, periodType:"dayly"},
    ()=>{
      if(newIndex==0){
        for(let i=0;i<this.state.dayly.length;i++){
          this.queryStats(i, true)
        }
      }
      if(newIndex==1||newIndex==2){
        this.queryStats(0, true)
      }
    }
  )
    // if(newIndex==2){
    //   setTimeout(()=>this.props.isLoading&&this.props.loading(false),1000)
    // }
  }

  onOpenCalendar(i, open=true){
    let newState = {...this.state}
    let sel = newState[this.state.periodType].slice(0)
    sel[i].open=open
    newState[this.state.periodType] = sel
    this.setState(newState)
  }

  onSelectCalendar(d, idx){
    let ds = moment(d)
    const period = this.state.periodType
    let newState = {...this.state}
    let sel = newState[this.state.periodType].slice(0)
    if(period!="custom"){
      sel[idx].open=false
    }else{
      if(sel[idx].from&&!sel[idx].to&&ds.isSameOrAfter(sel[idx].from,'d')){//Si está seleccionado el from y no el end y el valor es mayor al from, coloco el end
        sel[idx].to=d
        sel[idx].open=false
      }else{  //cualquier otro caso selecciono el from
        sel[idx].from=d
        sel[idx].to=null
      }
    }
    newState[period] = sel
    this.setState(newState)
  }

  onChangeCalendar(d, idx){
    const period = this.state.periodType
    let ds = moment(d)
    let newState = {...this.state}
    let sel = newState[this.state.periodType].slice(0)
    switch (period) {
      case 'weekly':
        sel[idx].from=d
        sel[idx].to=new Date(ds.add(6,'d').format("MM-DD-YYYY"))
        sel[idx].open=false
        break;
      case 'custom':
        if(sel[idx].from&&!sel[idx].to&&ds.isSameOrAfter(sel[idx].from,'d')){//Si está seleccionado el from y no el end y el valor es mayor al from, coloco el end
          sel[idx].open=false
        
        }
        break;
      default: 
        sel[idx].from=d
        sel[idx].to=null
        sel[idx].open=false
        break;
    }
    
    newState[period] = sel
    this.setState(newState)
    if(!sel[idx].open){
      this.queryStats(idx,false)
    }
    
  }

  onChangePeriod(evt){
    let p = evt.target.value
    this.setState({periodType:p},()=>{
      if(this.state.tabIndexSelected==0){
        for(let i=0;i<this.state.dayly.length;i++){
          this.queryStats(i, true)
        }
      }
      if(this.state.tabIndexSelected==1){
        this.queryStats(0, true)
      }
    })
  }

  onChangeDatesFromTab1(d){
    this.setState({fromTab1:d},this.queryStats)
  }

  onChangeDatesEndTab1(d){
    this.setState({endTab1:d}, this.queryStats)
  }

  onChangeUnit(evt){
    this.setState({unit:evt.target.value},
      ()=>{
        if(this.state.tabIndexSelected==1){
          this.queryStats(0, true)
        }
      }
    )
  }
  
  onChangeItems(evt){
    this.setState({items:evt.target.value},
      ()=>{
        if(this.state.tabIndexSelected==1){
          this.queryStats(0, true)
        }
      }
    )
  }
  
  onChangeCheck(check){
    // this.props.loading(true)
    let newState = this.state
    newState[check] = !newState[check]
    this.setState(newState)
    if(this.state.tabIndexSelected==0){
      for(let i=0;i<this.state.dayly.length;i++){
        this.queryStats(i, true)
      }
    }
    if(this.state.tabIndexSelected==1){
      this.queryStats(0, true)
    }
  }

  onChangeDatesFromTab2(d){
    this.setState({fromTab2:d},this.queryStats)
  }

  onChangeDatesEndTab2(d){
    this.setState({endTab2:d}, this.queryStats)
  }

  onViewDaylyDetailLiq(item){
    let dayDetailLiq = {...this.state.dayDetailLiq}
    let dayDetailLiqKey = moment(item.ordDate).format("MMMM YYYY")
    if(dayDetailLiq[dayDetailLiqKey]){
      delete dayDetailLiq[dayDetailLiqKey]
    }else{
      this.props.actionLiqResumeStats([item.ordDate, item.ordDate], true, 
        (monthResume)=>{
          let dayDetailLiq = {...this.state.dayDetailLiq}
          dayDetailLiq[dayDetailLiqKey] = monthResume
          this.setState({dayDetailLiq:dayDetailLiq})
        },
        ()=>{Util.showNoty(ERROR, "Ocurrió un error al consultar los datos. Intente nuevamente.")}
      )
    }
    this.setState({dayDetailLiq})
  }

  onViewDetailLiq(item){
    let detailLiq = {...this.state.detailLiq}
    let detailLiqKey = moment(item.ordDate).format("dddd DD")
    if(detailLiq[detailLiqKey]){
      delete detailLiq[detailLiqKey]
      this.setState({detailLiq:detailLiq})
    }else{
      // let d = []
      // let tipos = ["Delivery", "Take Away", "Mesa"]
      // for(let i = 0;i<90;i++){
      //   d.push({ordDate:new Date(), ordNumber:i+1, ordBuyer:"Alguno", ordType:tipos[i%3], ordPayType:i%2?"Efectivo":"Tarjeta", ordPrice:i*20, ordTaxes:i/4})
      // }
      this.props.actionLiqDetailStats(item.ordDate, 
        (dayDetail)=>{
          let detailLiq = {...this.state.detailLiq}
          detailLiq[detailLiqKey] = dayDetail
          this.setState({detailLiq:detailLiq})
        },
        ()=>{Util.showNoty(ERROR, "Ocurrió un error al consultar los datos. Intente nuevamente.")}
        )
    }
    
  }

  renderFilterWeekly(){
    const theme = this.props.theme
    const t = this.state.periodType
    const sel = this.state[t]
    
    return (
    <Grid container style={{justifyContent:"space-between", margin:4, marginLeft:"9%", marginRight:"15%"}} spacing={4}> 
      {aux.map((i, idx)=>{
        return (
          <Grid item>
            {this.state.loadingData[i]?
              <CircularProgress size={20}/>:
              <DatePicker onChange={(d)=>this.onChangeCalendar(d,i)} 
                          onSelect={(d)=>this.onSelectCalendar(d, i)} 
                          selected={sel[i].from}
                          selectStart
                          selectEnd
                          startDate={sel[i].from}
                          endDate={sel[i].to}
                          shouldCloseOnSelect={this.state.periodType!='custom'}
                          locale="es"
                          // onMonthChange={(d)=>this.onChangeCalendar(d,i)}
                          customInput={<ButtonCalendar from={sel[i].from} to={sel[i].to} period={this.state.periodType} onPress={()=>{this.onOpenCalendar(i)}} />}
                          showMonthYearPicker={this.state.periodType=='monthly'}
                          open={sel[i].open}
                          maxDate={new Date()}
                          >
                  <Box>
                    <Button color="primary" size="small" fullWidth onClick={()=>{this.onOpenCalendar(i,false)}}>
                      Cerrar
                    </Button>
                  </Box>
              </DatePicker>
            }
          </Grid>
        )
      })}
    </Grid>
    )
  }

  renderTopClient(topClients, stats){
    let topClientRender = topClients&&topClients.map((clients, i)=>{

      let tc = clients&&clients[this.state.unit]&&clients[this.state.unit].map(c=>{return ({img:c.photo, points:c[this.state.unit], label:c.tktBuyerName})})||[]
      return (
        <Grid item>
          <TopCard title="Top de Clientes" itemList={tc} subheader={stats[i].date}/>  
        </Grid> 
      ) 

    })
    return topClientRender
 
  }

  renderTab0(){
    let stats = this.state.orderStats
    // console.log("STATS", stats)
    let lbl = (p, s, f)=>{
      // console.log("P", p)
      let {x, y, fill, value, width, height, offset, index} = p
      let size = height>12?12:8
      
      if(height>0){ 
        let label =  s[index][f]
        if(this.state.unit=="Total")
          label = Util.formatCurrency(s[index][f])
        return <text 
        x={x+width/2} 
        y={y+height/2+3}  
        fontSize={size}
        fontFamily='sans-serif'
        fill={fill}
        textAnchor="middle">{label}</text>
      }
    }
 
    let dataKeys=[`stsCash${this.state.unit}`, `stsCard${this.state.unit}`, `stsTakeAway${this.state.unit}`,`stsDelivery${this.state.unit}`, `stsTable${this.state.unit}`]
    let period = this.state.periodType
    let sel = this.state[period]
    if(stats){
      for(let i=0;i<stats.length;i++){
        if(!stats[i]){
          stats[i]={}
        }
        let from=sel[i].from
        let to=sel[i].to 
        switch(period){

          case "dayly": stats[i].date = moment(from).format("DD/MM/YYYY"); break; 
          // case "weekly": 
          case "monthly": stats[i].date =  moment(from).format("MM/YYYY"); break;
          default: stats[i].date = `${moment(from).format("DD/MM/YYYY")} - ${moment(to).format("DD/MM/YYYY")}`; break;
        }
      
      }
    }
    return (
      <Grid container>
        {this.renderFilterWeekly()}
        <Grid container>
          {stats&&stats.length>0?
          <ResponsiveContainer height={300} width="100%">
            <BarChart data={stats}> 
              <TooltipBar/>
              <XAxis dataKey="date"></XAxis>
              <YAxis></YAxis>
              <Bar dataKey={dataKeys[0]} stackId="paymentType" fill="#FF5733" label={(p)=>lbl(p,stats,dataKeys[0])} name="Efectivo" legendType="circle"/>
              <Bar dataKey={dataKeys[1]} stackId="paymentType" fill="#FFA200" label={(p)=>lbl(p,stats,dataKeys[1])} name="Tarjeta" legendType="circle"/>
              <Bar dataKey={dataKeys[2]} stackId="type" fill="#A40505" label={(p)=>lbl(p,stats,dataKeys[2])} name="TakeAway" legendType="circle"/>
              <Bar dataKey={dataKeys[3]} stackId="type" fill="#E10707" label={(p)=>lbl(p,stats,dataKeys[3])} name="Delivery" legendType="circle"/>
              <Bar dataKey={dataKeys[4]} stackId="type" fill="#C95933" label={(p)=>lbl(p,stats,dataKeys[4])} name="Mesa" legendType="circle"/>
              <Legend align="right" layout="vertical" verticalAlign="top" legendType="circle" />
            </BarChart>
          </ResponsiveContainer>
          :<Typography style={{width:"100%", textAlign:"center", padding:10}}>No se encontraron datos para los filtros ingresados</Typography>
        }
        </Grid>
        <Grid container style={{marginLeft:"5%"}} spacing={4}> 
          {this.renderTopClient(this.state.topClientStats, stats)}
        </Grid>
      </Grid>
    )
  }
  
  renderTab1(){
    let stats = this.props.mnuStats
    let menus = stats&&this.props.menus&&this.props.menus.filter((m)=>{
      for(let i = 0;i<stats.length;i++){
        if(stats[i].menuItems[m.tktDisplayName]){
          return true
        }
      }
      return false
    })
  
    let lbl = (p)=>{
      let {x, y, fill, value, width, height, offset} = p
      let size = height>12?12:8
      if(height>0){ 
        return <text 
        x={x+width/2} 
        y={y+height/2+3}  
        fontSize={size}
        fontFamily='sans-serif'
        fill={fill}
        textAnchor="middle">{value}</text>
      }
    }
    let color=(index, count, v, a)=>{
      let h = index*360/count
      return `hsla(${h}, 50%, ${v}%, ${a})`
    }
    let field = this.state.unit == 'Qt' ? "stsMenuQt":"stsTotal"
    return (
      <Box>
        <Grid container spacing={4}> 
          <Grid item>
            <Typography className="MuiFormLabel-root MuiInputLabel-shrink">Desde</Typography>
            <DatePicker onChange={this.onChangeDatesFromTab1}
                        selected={this.state.fromTab1}
                        showMonthYearPicker={this.state.periodType=='monthly'}
                        showWeekNumbers={this.state.periodType=='weekly'}
                        customInput={<ButtonCalendar from={this.state.fromTab1} period={this.state.periodType} useWeek/>}
                        maxDate={new Date()}
                        />
          </Grid>
          <Grid item>
            <Typography className="MuiFormLabel-root MuiInputLabel-shrink">Hasta</Typography>
            <DatePicker onChange={this.onChangeDatesEndTab1}
                        selected={this.state.endTab1}
                        showMonthYearPicker={this.state.periodType=='monthly'}
                        showWeekNumbers={this.state.periodType=='weekly'}
                        customInput={<ButtonCalendar from={this.state.endTab1} period={this.state.periodType} useWeek/>}
                        maxDate={new Date()}
                        />
          </Grid>
        </Grid>
      {stats&&stats.length>0?
        <ResponsiveContainer height={300} width="100%">
          <LineChart data={stats}>
            <TooltipBar wrapperStyle={{zIndex:9999}}/>
            <XAxis dataKey="stsDate" ></XAxis>
            <YAxis></YAxis>
            {/* <Line dataKey="price" stroke={color(index,50, 0.9)} type="monotone" name={item.stsMnuName}/> */}
            {menus&&menus.map((item, index)=>{
              return (
                <Line dataKey={`menuItems[${item.tktDisplayName}].${field}`} stroke={color(index,menus.length,50, 0.9)} type="monotone" name={item.tktDisplayName}/>
              )
            })}
            <Legend />
          </LineChart>
        </ResponsiveContainer>
        :<Typography style={{width:"100%", textAlign:"center", padding:10}}>No se encontraron datos para los filtros ingresados</Typography>
        }
      {stats&&stats.map((item, index)=>{
        return (
          <Table stickyHeader>    
            <TableHead >
              <TableRow >
                <TableCell style={{backgroundColor:"black"}}>
                  <Typography style={{fontWeight:"bold", color:"white"}}>{item.stsDate}</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(item.menuItems).map((name)=>{
                return (
                  <TableRow>
                    <TableCell>
                      <StatCard info={item.menuItems[name]} title={name} unit={this.state.unit}/>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        )
        
      })}
      
      
      </Box>
    )
  }
  
  renderTab2(){ //Liquidación
    const {theme, liqResume} = this.props
    // let items =  [{ordDate:"Enero", 
    //               ordSelled:{
    //                 ordTotalCashTable:500, ordTotalCardTable:600,
    //                 ordTotalCashDelivery:300, ordTotalCardDelivery:200,
    //                 ordTotalCashTakeAway:100, ordTotalCardTakeAway:700
    //               },
    //               ordTaxes:{
    //                 ordTotalCashTable:200, ordTotalCardTable:700,
    //                 ordTotalCashDeliveryTA:600, ordTotalCardDeliveryTA:400
    //               }
    //             }]
    // for(let i = 2;i<=12;i++){
    //   let newItem = {...items[0]}
    //   if(i<10){
    //     newItem.ordDate="Febrero"
    //   }else{
    //     newItem.ordDate=""+i+"/2020"
    //   }
    //   items.push(newItem)
    // }
    return (
      [<Grid container spacing={4}>
        <Grid item>
          <Typography className="MuiFormLabel-root MuiInputLabel-shrink">Desde</Typography>
          <DatePicker onChange={this.onChangeDatesFromTab2}
                      selected={this.state.fromTab2}
                      showMonthYearPicker={true}
                      popperPlacement="top-end"
                      customInput={<ButtonCalendar from={this.state.fromTab2} period="monthly" />}
                      maxDate={new Date()}
                      />
        </Grid>
        <Grid item>
          <Typography className="MuiFormLabel-root MuiInputLabel-shrink">Hasta</Typography>
          <DatePicker onChange={this.onChangeDatesEndTab2}
                      selected={this.state.endTab2}
                      showMonthYearPicker={true}
                      popperPlacement="top-end"
                      customInput={<ButtonCalendar from={this.state.endTab2} period="monthly" />}
                      maxDate={new Date()}
                      />
        </Grid>
      </Grid>,
      liqResume&&liqResume.map((item)=>{
        let dayDetailLiqKey = moment(item.ordDate).format("MMMM YYYY")
        return (
          <Table stickyHeader>    
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography style={{fontWeight:"bold", letterSpacing:2, fontSize:20, color:"black"}}>{_.capitalize(dayDetailLiqKey)}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Button onClick={()=>{this.onViewDaylyDetailLiq(item)}}>
                    <ListAlt style={{marginRight:4}}/>{this.state.dayDetailLiq[dayDetailLiqKey]?"Resumen":"Detalle"}
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.dayDetailLiq[dayDetailLiqKey]?
                this.state.dayDetailLiq[dayDetailLiqKey].map((detail)=>{
                  let detailLiqKey = moment(detail.ordDate).format("dddd DD")
                  return [
                    <TableRow style={{backgroundColor:"black"}} >
                      <TableCell >
                        <Typography style={{color:"#fff", fontWeight:"lighter", letterSpacing:1}}>{_.capitalize(detailLiqKey)}</Typography>
                      </TableCell>
                      <TableCell style={{backgroundColor:"black"}} align="right">
                        <Button onClick={()=>{this.onViewDetailLiq(detail)}} color="primary" style={{color:"#fff"}}>
                          <ListAlt style={{marginRight:4}}/>{this.state.detailLiq[detailLiqKey]?"Resumen":"Detalle"}
                        </Button>
                      </TableCell>
                    </TableRow>,
                    <TableRow>
                      {this.state.detailLiq[detailLiqKey]?
                        <TableCell colSpan={2}>
                          <TableLiq items={this.state.detailLiq[detailLiqKey]}/>
                        </TableCell>
                      :[
                      <TableCell>
                        <GridTotal item={detail.ordSelled} theme={theme} isTaxes={false}/>
                      </TableCell>,
                      <TableCell>
                        <GridTotal item={detail.ordTaxes} theme={theme} isTaxes={true}/>
                      </TableCell>
                      ]
                    }
                    </TableRow>
                   ] 
                })
              :
              <TableRow>
                <TableCell>
                    <GridTotal item={item.ordSelled} theme={theme} isTaxes={false}/>
                </TableCell>
                <TableCell>
                  <GridTotal item={item.ordTaxes} theme={theme} isTaxes={true}/>
                </TableCell>
              </TableRow>
              }
            </TableBody>
          </Table>
        )
      })  
    ]
    )
  }
  render(){
    const { theme, handleSubmit, history, ordStats, mnuStats, restaurant, topClient, topMenu } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Estadísticas</Typography>
            <Typography variant="subtitle1">Comercio {restaurant.evtName}</Typography>
          </Box>
        </Box>
        <Container>        
          <Tabs value={this.state.tabIndexSelected} style={{backgroundColor:"black", color:"white"}} onChange={this.onChangeTab}>
              <Tab label="Pedidos"/>
              <Tab label="Items de Menú"/>
              <Tab label="Liquidación"/>
            </Tabs>
          <Paper style={theme.paper.form}>          
            {this.state.tabIndexSelected<2&&
            <Toolbar style={{justifyContent:"space-between"}}>
              <FormControl>
                <InputLabel shrink>Periodo</InputLabel>
                <Select  style={{...theme.orders.selectView, paddingBottom:4}} value={this.state.periodType} onChange={this.onChangePeriod}>
                  <MenuItem value="dayly">Diario</MenuItem>
                  <MenuItem value="weekly">Semanal</MenuItem>
                  <MenuItem value="monthly">Mensual</MenuItem>
                  {this.state.tabIndexSelected==0?<MenuItem value="custom">Rango</MenuItem>:null}
                </Select>
              </FormControl>
      
            <FormControl>
              <InputLabel shrink>Unidad</InputLabel>
              <Select  style={{...theme.orders.selectView, paddingBottom:4}} value={this.state.unit} onChange={this.onChangeUnit}>
                <MenuItem value="Qt">Cantidad</MenuItem>
                <MenuItem value="Total">Dinero</MenuItem>
              </Select>
            </FormControl>
            {this.state.tabIndexSelected==1&&
            <FormControl>
              <InputLabel shrink>Items</InputLabel>
              <Select  style={{...theme.orders.selectView, paddingBottom:4}} value={this.state.items} onChange={this.onChangeItems}>
                <MenuItem value="top15">TOP 15</MenuItem>
                <MenuItem value="top10">TOP 10</MenuItem>
                <MenuItem value="less10">Los 10 peores</MenuItem>
              </Select>
            </FormControl>
              }
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.takeAway}
                      onChange={()=>this.onChangeCheck('takeAway')}
                      color="primary"
                    />
                  }
                  label="Take Away"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.delivery}
                      onChange={()=>this.onChangeCheck('delivery')}
                      color="primary"
                    />
                  }
                  label="Delivery"
                />
                 <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.table}
                      onChange={()=>this.onChangeCheck('table')}
                      color="primary"
                    />
                  }
                  label="Mesa"
                />
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.cash}
                      onChange={()=>this.onChangeCheck('cash')}
                      color="primary"
                    />
                  }
                  label="Efectivo"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.card}
                      onChange={()=>this.onChangeCheck('card')}
                      color="primary"
                    />
                  }
                  label="Tarjeta"
                />
              </Box>
            </Toolbar>
            }
            {this[`renderTab${this.state.tabIndexSelected}`]()}
            {/* <Grid container spacing={4} xs={12}>
              <Grid item >
                <TopCard title="Top de Clientes" itemList={topClient.map(c=>{return ({img:c.photo, points:c.points, label:c.name})})}/>
              </Grid>
               <Grid item xs={6}>
                <TopCard title="Top de Menú" itemList={topMenu.map(c=>{return ({img:c.photo, points:c.points, label:c.name})})}/>
              </Grid> 
            </Grid> */}
          </Paper>
        </Container>
        
      </Box>
    )
  }
}
function mapStateToProps(store) {
  return {
    login: store.auth.login,
    stats: Mock.statsMock,//
    ordStats: store.sts.ordStats,//Mock.statsMock,//
    mnuStats: store.sts.mnuStats,
    liqResume: store.sts.liqResume,
    topClient: Mock.topClient.sort((a,b)=>{return b.points-a.points}), //store.sts.topClientStats //
    topMenu: Mock.topMenu.sort((a,b)=>{return b.points-a.points}),//store.evt.stats,
    restaurant: store.evt.restaurant,
    menus: store.evt.ticketTypeList,
    isLoading: store.app.loading
//    {id:"3bOtLlLdEo7pjesqhvRZ" ,evtName:"Prueba"}
    //eventPlace: store.form.addEditRestaurant
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionOrdersStats,
      actionTopClientStats,
      actionMenuStats,
      actionGetTicketTypes,
      actionLiqResumeStats,
      actionLiqDetailStats,
      loading
    },
    dispatch
  );
}

// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(Statistics)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/restaurants/Statistics.js